export * from './delete-gutachten-status.component';
export * from './delete-gutachten-status.component.module';